// extracted by mini-css-extract-plugin
module.exports = {"btnCol":"invoicesimplifiedheader_btnCol__1Ah2L"};